// removed by extract-text-webpack-plugin
module.exports = {"root":"root___2kyNt"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Operation/Merchant/components/PersonalInfo/Index.less
// module id = 8mUv
// module chunks = 3 4